import React from "react";

import { UseFormReturn } from "react-hook-form";

import {
    Box,
    Button,
    Typography
} from "@mui/material";

import {
    t,
    Trans
} from "@lingui/macro";

import {
    ZPlayLoader,
    NavigationBack
} from "commons";

import { ManageCouponState } from "./models";
import { DefaultTypedResponse } from "models/response";


import { ContentProducerService } from "services/content-producer-service";
import AddIcon from "@mui/icons-material/Add";
import { withSnackbar, WithSnackbarProps } from "notistack";

import { Coupon } from "models";
import { CouponTable, CreateAndEditCouponModal } from "components/backoffice/coupon/index";


class ManageCoupon extends React.Component<UseFormReturn & WithSnackbarProps, ManageCouponState>{

    constructor(props: any) {
        super(props);

        this.state = {
            searchFilter: null,
            pagination: { pageSize: 20, pageIndex: 0 },
            couponCount: 0,
            couponList: [],
            data: null,
            isLoading: true,
            openEditCouponModal: false,
            openCreateCouponModal: false,
            editCoupon: null
        };
    }


    public componentDidMount() {
        this.getPaginatedCouponWithStateParameters();
    };

    private paginationUpdated = (pagination: any) => {

        ////****
        //VERY IMPORTANTE! Mongoose Paginate prende di default come prima pagina la pagina 1, mentre la tabella la pagina 0. Serve questo piccolo workaround
        ////****

        this.setState(
            () => ({
                isLoading: true,
                pagination: pagination
            }),
            () => ContentProducerService.getCouponListPaginated([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getCouponCallback, this.getCouponErrorCallback)
        );

    }

    private getPaginatedCouponWithStateParameters = () => {

        this.setState(() => ({
            isLoading: true,
        }));

        ContentProducerService.getCouponListPaginated([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getCouponCallback, this.getCouponErrorCallback);
    }

    private deleteCoupon = (id: string): void => {

        this.setState(() => ({
            isLoading: true,
        }));

        if ((this.state.couponList.length - 1) % this.state.pagination.pageSize === 0 && this.state.pagination.pageIndex !== 0) {
            this.setState((prevState) => ({
                pagination: {
                    ...prevState.pagination,
                    pageIndex: this.state.pagination.pageIndex - 1
                }
            }));
        };

        ContentProducerService.deleteCoupon(id, this.getPaginatedCouponWithStateParameters, this.deleteCouponErrorCallback);
    }


    private getCouponCallback = (data: DefaultTypedResponse<Coupon>): void => {

        this.setState(() => ({
            couponCount: data.size,
            couponList: data.list,
            isLoading: false,
        }));
    };

    private editCouponCallback = (): void => {
        this.setState(() => ({ openEditCouponModal: false }));
        this.getPaginatedCouponWithStateParameters();
    };

    private createCouponCallback = (): void => {
        this.setState(() => ({ openCreateCouponModal: false }));
        this.getPaginatedCouponWithStateParameters();
    };

    private deleteCouponErrorCallback = (err: any): void => {
        this.setState(() => ({
            isLoading: false
        }));

        this.props.enqueueSnackbar(t({
            id: "mcm-error-delete-coupon",
            message: "Si è verificato un errore. Il coupon non è stato eliminato"
        }), {
            variant: "error",
        });
    }

    private getCouponErrorCallback = (err: any): void => {
        this.setState(() => ({
            isLoading: false
        }));

        this.props.enqueueSnackbar(t({
            id: "mcm-error-get-coupon",
            message: "Si è verificato un errore."
        }), {
            variant: "error",
        });
    };

    private editCouponErrorCallback = (err: any): void => {
        this.setState(() => ({
            openEditCouponModal: false
        }));

        this.props.enqueueSnackbar(t({
            id: "mcm-error-edit-coupon",
            message: "Si è verificato un errore. Il coupon non è stato modificato"
        }), {
            variant: "error",
        });
    };

    private createCouponErrorCallback = (err: any): void => {
        this.setState(() => ({
            openCreateCouponModal: false
        }));

        this.props.enqueueSnackbar(t({
            id: "mcm-error-create-coupon",
            message: "Si è verificato un errore. Il coupon non è stato creato"
        }), {
            variant: "error",
        });
    };


    private openEditCouponModal = (coupon: Coupon): void => {
        this.setState(() => ({
            openEditCouponModal: true,
            editCoupon: coupon
        })
        )
    }

    private closeModal = (): void => {
        this.setState(() => ({
            openEditCouponModal: false,
            editCoupon: null,
            openCreateCouponModal: false,
        }));
    };

    private openCreateCouponModal = (): void => {
        this.setState(() => ({
            openCreateCouponModal: true,
        })
        )
    }

    render() {
        return (
            <Box sx={{ textAlign: "center", p: 5 }}>
                <NavigationBack/>
                <Typography variant="h2" color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                    <Trans id="mcm-text-title">Codici sconto e regalo</Trans>
                </Typography>
                <Box sx={{ textAlign: "right", pr: 2 }}>
                    <Button
                        endIcon={<AddIcon />}
                        onClick={this.openCreateCouponModal}
                        variant={"contained"}
                    >
                        <Trans id="mcm-button-add">Aggiungi</Trans>
                    </Button>
                </Box>
                {<Box sx={{ p: 2, mt: 2 }}>
                    <CouponTable
                        pagination={this.state.pagination}
                        coupons={this.state.couponList}
                        totalCouponCount={this.state.couponCount}
                        deleteCoupon={this.deleteCoupon}
                        openEditCouponTable={this.openEditCouponModal}
                        updatePaginationCallBackFn={this.paginationUpdated}
                    />
                </Box>}
                {this.state.openEditCouponModal && <CreateAndEditCouponModal
                    closeModal={this.closeModal}
                    editCouponCallback={this.editCouponCallback}
                    editCouponErrorCallback={this.editCouponErrorCallback}
                    coupon={this.state.editCoupon}
                />}
                {this.state.openCreateCouponModal && <CreateAndEditCouponModal
                    closeModal={this.closeModal}
                    createCouponCallback={this.createCouponCallback}
                    createCouponErrorCallback={this.createCouponErrorCallback}
                />}
                {this.state.isLoading && <ZPlayLoader />}
            </Box>);
    }
}

export default withSnackbar(ManageCoupon);